import * as type from './types';
import axios from '../../../common/config/axios';

export const getAgentInbox = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    data.lang_id = getState().currentUser.data.language_id;
    axios.get('agent_inbox/list', {params: data})
    .then((res) => {
        dispatch({
            type: type.GET_AGENT_INBOX,
            payload: res
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: type.GET_AGENT_INBOX,
        //     payload: []
        // });
    });
}

export const showAgentInbox = (data) => dispatch => {
    axios.get('agent_inbox/show', {params: data})
    .then((res) => {
        dispatch({
            type: type.SHOW_AGENT_INBOX,
            payload: res
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: type.SHOW_AGENT_INBOX,
        //     payload: []
        // });
    });
}

export const dropdownAgentInbox = (data) => (dispatch, getState) => {
    data.country_id = getState().currentUser.data.country_id;
    data.lang_id = getState().currentUser.data.language_id;
    axios.get('agent_inbox/dropdown', {params: data})
    .then((res) => {
        dispatch({
            type: type.DROPDOWN_AGENT_INBOX,
            payload: res
        });
    })
    .catch((err) => {
        // dispatch({
        //     type: type.DROPDOWN_AGENT_INBOX,
        //     payload: []
        // });
    });
}

export const createAgentInbox = (data) => (dispatch, getState) => {
    axios.post('agent_inbox/store', data)
    .then((res) => {
        dispatch ({
            type: type.CREATE_AGENT_INBOX,
            payload: res
        });
    }).catch((err) => {
        // dispatch({
        //     type: type.CREATE_AGENT_INBOX,
        //     payload: []
        // });
    });
};